import MatchedPhotosSortFilter from './MatchedPhotosSortFilter';

export default MatchedPhotosSortFilter;
